// Brinde no carrinho: mantém 1 unidade do produto de brinde sempre que houver outro produto no carrinho,
// e remove o brinde quando ele for o único item. O preço zero vem de um desconto automático no admin.
// A linha do brinde é marcada com a propriedade oculta "_brinde", pois o mesmo produto também é vendido.
// Com o brinde desativado nas configurações, apenas remove brindes que tenham ficado em carrinhos antigos.

const giftVariantId = window.themeVariables?.settings?.giftVariantId;

{
  let busy = false;
  let failed = false;

  const collectSections = () => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));
    return sections;
  };

  const publishCart = (cart, sections) => {
    if (window.themeVariables.settings.pageType === 'cart') {
      return window.location.reload();
    }

    cart['sections'] = sections;
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'variant:add', cart }
    }));
  };

  const isGiftLine = (item) => Boolean(item['properties']?.['_brinde']);

  const syncGift = async (cart) => {
    if (busy || failed) {
      return;
    }

    const giftLines = cart['items'].filter(isGiftLine);
    const giftLine = giftLines[0];
    const hasOtherItems = cart['items'].some((item) => !isGiftLine(item));

    let request;

    if (!giftVariantId && giftLine) {
      request = { url: 'cart/change.js', body: { id: giftLine['key'], quantity: 0 } };
    } else if (!giftVariantId) {
      return;
    } else if (hasOtherItems && !giftLine) {
      request = { url: 'cart/add.js', body: { items: [{ id: giftVariantId, quantity: 1, properties: { '_brinde': '1' } }] } };
    } else if (!hasOtherItems && giftLine) {
      request = { url: 'cart/change.js', body: { id: giftLine['key'], quantity: 0 } };
    } else if (giftLines.length > 1) {
      request = { url: 'cart/change.js', body: { id: giftLines[1]['key'], quantity: 0 } };
    } else if (giftLine && giftLine['quantity'] > 1) {
      request = { url: 'cart/change.js', body: { id: giftLine['key'], quantity: 1 } };
    } else {
      return;
    }

    busy = true;

    try {
      const sections = collectSections();
      const response = await fetch(`${Shopify.routes.root}${request.url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ ...request.body, sections: sections.join(',') })
      });
      const responseJson = await response.json();

      if (!response.ok) {
        failed = true;
        console.warn('Brinde no carrinho:', responseJson['description'] || responseJson['message']);
        return;
      }

      const updatedCart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      busy = false;
      publishCart(updatedCart, responseJson['sections']);
    } finally {
      busy = false;
    }
  };

  document.addEventListener('cart:change', (event) => syncGift(event.detail['cart']));

  const syncFromServer = async () => syncGift(await (await fetch(`${Shopify.routes.root}cart.js`)).json());

  document.addEventListener('cart:refresh', syncFromServer);
  window.addEventListener('pageshow', syncFromServer);
}
